
export function isValidNumber(value) {
  return !isNaN(value);
}

export function isValidDate(dateObject) {
  return new Date(dateObject).toString() !== "Invalid Date";
}

export function calc_days(date1, date2 = null) {
  const ONE_DAY = 1000 * 60 * 60 * 24;
  const dateObj1 = new Date(date1);
  const dateObj2 = date2 ? new Date(date2) : new Date();
  const timeDifference = dateObj2 - dateObj1;
  const dayDifference = Math.round(timeDifference / ONE_DAY);
  return dayDifference;
}

export const getDisputeStatus = (muthoot_status) => {
  switch(muthoot_status) {
    case 'MD_Reject':
      return 'MD';
    case 'Forward_MD':
    case 'IO_Reject':
    case 'Forward_IO':
      return 'IO';
    case 'Forward_Nodal':
    case 'Nodal_After_Review':
    case 'GRO_After_Review':
      return 'PNO';
    case 'Forward':
    case 'RO_After_Review':
      return 'ZO';
    case 'RO_Accept':
      return 'RO';
    default:
      return 'RO';
  }
}

export const getMuthootRole = (muthoot_status) => getDisputeStatus(muthoot_status);

export const getOpenClosedStatus = (status) => status === 'closed' ? 'Closed' : 'Open';
